// extracted by mini-css-extract-plugin
export var alertIcon = "_q7-0";